export const isOnlyCompactMode = (fileType: string) => {
    return ["doc", "docx", "txt", "rtf", "odt", "key", "html", "ppt"].includes(fileType);
};

export const sizeByMode = (fileType: string) => {
    return {
        width: fileType === "pptx" ? BASE_PPTX_WIDTH : BASE_COMPACT_WIDTH,
        height: fileType === "pptx" ? BASE_PPTX_HEIGHT : BASE_COMPACT_HEIGHT,
    };
};

export const BASE_COMPACT_WIDTH = 80;
export const BASE_COMPACT_HEIGHT = 103;

export const BASE_PPTX_WIDTH = 80;
export const BASE_PPTX_HEIGHT = 80;
